module.exports = __webpack_public_path__ + "img/GLO.8d85e126.svg";